export const IMAGE_STATUS = {
  NEW: 'NEW',
  REGISTERED: 'REGISTERED',
  NEED_TO_DEL: 'NEED_TO_DEL',
  DEL: 'DEL',
  COPY: 'COPY',
};

export const IMAGE_MESSAGE = {
  DRAG_DROP: '첨부한 파일을 여기에 끌어 놓아 주세요.',
};

export const DND_IMAGE_ICON = 'IMAGE_ICON';

export const FILE_VALIDATION = {
  EXCEED_MAXIMUM_FILE_COUNT: '업로드 가능한 파일 개수를 초과하였습니다.',
  INVALID_FILE_EXTENSION: '업로드 가능한 확장자 파일이 아닙니다.',
  EXCEED_MAXIMUM_FILE_SIZE: '업로드 용량을 초과하였습니다.',
  EXCEED_MAXIMUM_TOTAL_SIZE: '업로드 용량을 초과하였습니다.',
};
